import moment from 'moment';
import React from 'react';

function charByteSize(ch) {
  if (ch == null || ch.length === 0) {
    return 0;
  }

  const charCode = ch.charCodeAt(0);

  if (charCode <= 0x00007f) {
    return 1;
  }
  if (charCode <= 0x0007ff) {
    return 2;
  }
  if (charCode <= 0x00ffff) {
    return 3;
  }
  return 4;
}
const convertFormatDate = (date, fromFormat, toFormat) => {
  const result = moment(date, fromFormat).format(toFormat);
  return result === 'Invalid date' ? '' : result;
};

const addByte = (byte, charByte, limiteByte) => {
  if (limiteByte && byte + charByte > limiteByte) {
    return 0;
  }
  return charByte;
};

const pimsCheckBytes = (value, maxByte) => {
  let textCount = 0;
  const byte = Number(maxByte);

  for (let i = 0; i < value.length; i++) {
    const oneChar = value.charAt(i);

    if (escape(oneChar).length > 4) {
      textCount += 3;
    } else if (oneChar !== '\n') {
      textCount++;
    }
  }

  if (textCount > byte) {
    return false;
  }
  return true;
};

const pimsCheckBytesReturnText = (value, maxByte) => {
  let byte = 0;
  let returnText = '';
  let isLimited = false;
  let char;

  if (value && value.length > 0) {
    let charByte = 0;
    for (let i = 0; i < value.length; i++) {
      char = value.charAt(i);
      charByte = charByteSize(char);

      const add = addByte(byte, charByte, maxByte);
      if (add > 0) {
        byte += add;
        returnText += char;
      } else {
        isLimited = true;
        break;
      }
    }
  }
  return { byte, returnText, isLimited };
};

export const openCenterWindow = (url, name, w = 900, h = 500, windowFeatures) => {
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  // fix case open from edge
  const width = window.innerWidth < w ? screen.width : window.innerWidth;
  const height = window.innerHeight < h ? screen.height : window.innerHeight;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  return window.open(
    url,
    name,
    `width=${w / systemZoom},height=${h / systemZoom},top=${top},left=${left},${windowFeatures}`,
  );
};

const interleaveString = (originalArray, interstring = '') => {
  return originalArray.filter(element => !!element).join(interstring);
};

export const getFormAppOptions = (contacts, user) => {
  const recipients = contacts
    .filter(({ emails }) => Array.isArray(emails) && emails.length)
    .map(
      ({
        emails,
        sourceId = '',
        fullName = '',
        compName = '',
        title = '',
        deptName = '',
        sourceType = 'EMPLOYEE',
        uid = '',
      }) => {
        let email = emails.find(currentEmail => currentEmail.priority === ContactConstants.PRIORITY.YES);
        if (!email) {
          email = emails[0];
        }
        return {
          displayName: interleaveString([fullName, title, deptName, compName], ' / '),
          email: email.val,
          sid: sourceType === 'EMP' ? sourceId : uid,
          sourceType,
          type: {
            calendar: 'REQ_PARTICIPANT',
            todo: true,
            mail: 'TO',
          },
        };
      },
    );

  const uniqueRecipients = [recipients[0]];
  recipients.forEach(element => {
    const duplicate = uniqueRecipients.find(
      item => item.email === element.email && item.sourceType === element.sourceType,
    );
    if (duplicate) {
      return;
    }
    uniqueRecipients.push(element);
  });

  const composeInfo = {
    initModule: 'mail',
    userId: user.LOGINID,
    domainModel: {
      contents: {
        type: 'html',
      },
      recipients: uniqueRecipients,
      domainSet: user.DOMAINSET,
      compDomain: user.COMPDOMAIN,
      popupWidth: 1200,
      popupHeight: 665,
    },
  };
  return composeInfo;
};

const detectClickOutSide = (callback, options = {}) => {
  const { excludeEle: excludeElement } = options;
  const elementRef = React.useRef(null);
  React.useEffect(() => {
    const handleMouseDown = ({ target }) => {
      const isOutSideElement = !elementRef.current || !elementRef.current.contains(target);
      const isExcludeEle = excludeElement !== undefined && target === excludeElement.current;
      if (isExcludeEle) return;
      if (isOutSideElement) {
        callback(target);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [callback, excludeElement]);
  return {
    elementRef,
  };
};

const isHtmlDocument = str => {
  if (typeof str !== 'string') return false;
  const trimmedStr = str.trim();

  // Check if it contains a doctype declaration
  if (/^<!DOCTYPE\s+html>/i.test(trimmedStr)) {
    return true;
  }

  // Check if it contains <html> tag
  if (/<html[\s>]/i.test(trimmedStr) && /<\/html>/i.test(trimmedStr)) {
    return true;
  }

  // Check for common HTML structure elements
  if (
    /<head[\s>]/i.test(trimmedStr) &&
    /<\/head>/i.test(trimmedStr) &&
    /<body[\s>]/i.test(trimmedStr) &&
    /<\/body>/i.test(trimmedStr)
  ) {
    return true;
  }

  // General HTML tag detection
  if (/<(?:[A-Za-z][A-Za-z0-9-]*)(?:\s+[^<>]*?)?>|<\/[A-Za-z][A-Za-z0-9-]*\s*>/i.test(trimmedStr)) {
    return true;
  }

  return false;
};
const htmlEscape = s => {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#039;')
    .replace(/"/g, '&quot;')
    .replace(/\n/g, '<br>')
    .replace(/`/g, '&#x60;')
    .replace(/=/g, '&#x3D;')
    .replace(/\//g, '&#x2F;');
};
const util = {
  openCenterWindow,
  pimsCheckBytes,
  pimsCheckBytesReturnText,
  detectClickOutSide,
  convertFormatDate,
  isHtmlDocument,
  htmlEscape,
};

export default util;
